import { X } from "lucide-react"
import React, { useEffect, useRef, useState } from "react"

const MultiSelect = ({ label, options, value = [], onChange, allLabel = "Всі" }) => {
  const [isOpen, setIsOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setIsOpen(false)
    }
    document.addEventListener("mousedown", handler)
    return () => document.removeEventListener("mousedown", handler)
  }, [])

  const toggle = (key) => {
    if (!key) {
      onChange([])
      return
    }
    onChange(value.includes(key) ? value.filter((v) => v !== key) : [...value, key])
  }

  const selectedLabels = options.filter((o) => value.includes(o.key)).map((o) => o.value)
  const displayText =
    selectedLabels.length === 0
      ? allLabel
      : selectedLabels.length === 1
        ? selectedLabels[0]
        : `${selectedLabels[0]} +${selectedLabels.length - 1}`

  return (
    <div className="flex flex-col gap-1" ref={ref}>
      <label className="text-xs font-medium text-slate-600">{label}</label>
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen((p) => !p)}
          className={`w-full px-3 py-2 border rounded-lg bg-white text-sm text-left appearance-none focus:outline-none focus:ring-2 flex items-center justify-between gap-2 ${
            value.length > 0
              ? "border-orange-400 text-slate-800"
              : "border-slate-300 text-slate-400"
          }`}
        >
          <span className="truncate">{displayText}</span>
          <div className="flex items-center gap-1 flex-shrink-0">
            {value.length > 0 && (
              <span
                className="w-4 h-4 bg-orange-500 rounded-full flex items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation()
                  onChange([])
                }}
              >
                <X className="w-2.5 h-2.5 text-white" />
              </span>
            )}
            <svg
              className="w-4 h-4 text-slate-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>
        </button>

        {isOpen && (
          <div className="absolute z-50 mt-1 w-full bg-white border border-slate-200 rounded-lg shadow-lg overflow-hidden">
            <div className="max-h-48 overflow-y-auto">
              <button
                type="button"
                onClick={() => {
                  onChange([])
                  setIsOpen(false)
                }}
                className={`w-full text-left px-3 py-2 text-sm transition-colors hover:bg-slate-50 ${
                  value.length === 0 ? "text-orange-600 font-medium bg-orange-50" : "text-slate-500"
                }`}
              >
                {allLabel}
              </button>
              {options.map((o) => {
                const isSelected = value.includes(o.key)
                return (
                  <button
                    key={o.key}
                    type="button"
                    onClick={() => toggle(o.key)}
                    className={`w-full text-left px-3 py-2 text-sm flex items-center gap-2 transition-colors hover:bg-slate-50 ${
                      isSelected ? "text-orange-600 font-medium" : "text-slate-700"
                    }`}
                  >
                    <span
                      className={`w-4 h-4 rounded border flex-shrink-0 flex items-center justify-center ${
                        isSelected ? "bg-orange-500 border-orange-500" : "border-slate-300"
                      }`}
                    >
                      {isSelected && (
                        <svg className="w-2.5 h-2.5 text-white" viewBox="0 0 10 10" fill="none">
                          <path
                            d="M2 5l2.5 2.5L8 3"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </span>
                    {o.value}
                  </button>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default MultiSelect
